import {
    INTERACTION_TYPES,
    PROCESS_TYPE,
    SECTION_CATEGORY,
    SECTION_FAMILY,
    SECTION_NAME,
    SERVICE_TYPE,
} from 'constants/uTagConstants/ga4';
import { getIsFirstOwner } from 'utilities/holders/holderTypes';

export const getGA4EventKeys = ({
    eventName,
    pageName,
    processDetail,
    interactionType,
    onboardingType,
    typeHolder,
    onboardingHolderType,
}) => {
    return {
        event_name: eventName,
        pageName,
        sectionFamily: SECTION_FAMILY,
        sectionCategory: SECTION_CATEGORY,
        sectionName: SECTION_NAME,
        interactionType: interactionType ?? INTERACTION_TYPES.FUNNEL,
        serviceType: SERVICE_TYPE,
        processType: PROCESS_TYPE,
        processDetail,
        onboardingType,
        ...(onboardingHolderType && { onboardingHolderType }),
        ...(typeHolder && { onboardingHolderType: getIsFirstOwner(typeHolder) }),
    };
};
